import React, { useState } from "react";

import {
	Stack,
	Button,
	Box,
	FormLabel,
	Switch,
	Typography,
	IconButton,
} from "@mui/material";

import { Iconify } from "@onair/minimal-ui/iconify";
import { SurveyPicker } from "#src/components/form-controls/select-survey/dialog/survey-picker.tsx";
import { SurveyFileSvg } from "#src/components/svg/files/survey-file-svg";
import { useGetMySurveys, useGetSurveysByUserIdQuery } from "@onair/operations";
import { SurveyDetailsDTO, SurveyUserDetailsDTO } from "@onair/repositories";
import { RHFSwitch } from "@onair/minimal-ui/hook-form";

export interface SelectSurveyProps {
	label?: string;
	name?: string;
	requiredName?: string;
	value?: string[];
	onChange: (selectedIds: string[]) => void;
	userId?: string;
	error?: {
		message?: string;
	};
	disabledAdd?: boolean;
}

export const SelectSurvey: React.FC<SelectSurveyProps> = (props) => {
	const {
		value,
		name,
		requiredName,
		userId,
		onChange,
		disabledAdd = false,
		...others
	} = props;

	const [openDialog, setOpenDialog] = useState<boolean>(false);

	const { data: mySurveysResult } = useGetMySurveys(
		{
			limit: Number.MAX_SAFE_INTEGER,
			offset: 1,
			ids: value || [],
		},
		{
			enabled: (value || []).length > 0 && !userId,
		},
	);

	const { data: userSurveysResult } = useGetSurveysByUserIdQuery(
		{
			userId: userId || "",
			limit: Number.MAX_SAFE_INTEGER,
			offset: 1,
			ids: value || [],
		},
		{
			enabled: (value || []).length > 0 && !!userId,
		},
	);

	const handleCloseDialog = () => {
		setOpenDialog(false);
	};

	const items: (SurveyDetailsDTO | SurveyUserDetailsDTO)[] = userId
		? userSurveysResult?.items || []
		: mySurveysResult?.items || [];

	return (
		<>
			<Stack className="gap-4">
				{items.length > 0 && (
					<>
						{items.map((item) => (
							<Stack className="rounded-xl p-4 bg-grey-100">
								<Stack className="rounded-lg bg-white p-2">
									<Stack className="gap-3 flex-row items-center">
										<Box>
											<SurveyFileSvg />
										</Box>
										<Typography variant="subtitle2">{item.title}</Typography>
									</Stack>
									<Stack
										direction="row"
										justifyContent="space-between"
										alignItems="center"
									>
										<RHFSwitch
											name={`${requiredName}.${item.id}`}
											label="Bắt buộc điền trước khi mua khoá học"
										/>
										<IconButton>
											<Iconify
												icon="solar:trash-bin-trash-bold"
												// @ts-ignore
												color={(theme) => theme.palette.error.main}
												onClick={() => {
													onChange(
														(value || []).filter((id) => id !== item.id),
													);
												}}
											/>
										</IconButton>
									</Stack>
								</Stack>
							</Stack>
						))}
					</>
				)}

				<Box>
					<Button
						variant="soft"
						startIcon={<Iconify icon="mingcute:add-line" />}
						color="primary"
						onClick={() => setOpenDialog(true)}
						disabled={disabledAdd}
					>
						Thêm form khảo sát
					</Button>
				</Box>

				<SurveyPicker
					open={openDialog}
					onClose={handleCloseDialog}
					onUpdate={onChange}
					selectedIds={value || []}
					userId={userId}
				/>
			</Stack>
		</>
	);
};
